import { useEffect } from "react";
import type { UseFormSetValue } from "react-hook-form";
import type { InvoiceFormData } from "@/types";

type Params = {
    userRole: string;
    isDirtyInvoiceDate?: boolean;
    setValue: UseFormSetValue<InvoiceFormData>;
};

export function useClientDefaultInvoiceDate({ userRole, isDirtyInvoiceDate, setValue }: Params) {
    useEffect(() => {
        if (userRole === "Client" && !isDirtyInvoiceDate) {
            setValue("invoiceDate", new Date().toISOString().split("T")[0]);
        }
    }, [userRole, isDirtyInvoiceDate, setValue]);
}
